import api from '@/api/index.js'

const account_audit_logs = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_ACCOUNT_AUDIT_LOGS_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_ACCOUNT_AUDIT_LOGS: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_ACCOUNT_AUDIT_LOGS_ERROR: (state, error) => {
      state.error = error;
      state.loading = false;
    }
  },

  actions: {
    LoadAccountAuditLogs({commit}, payload) {
      commit('SET_ACCOUNT_AUDIT_LOGS_ERROR', null)
      commit('SET_ACCOUNT_AUDIT_LOGS_LOADING', true)
      return api.get(`accounts/${payload.id}/audit-logs?filter=${payload.query.filter}&action_result=${payload.query.action_result}&id=${payload.query.id}&limit=${payload.query.limit}&offset=0`)
        .then((response) => {
          commit('SET_ACCOUNT_AUDIT_LOGS', response)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_AUDIT_LOGS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    }
  },
}

export default account_audit_logs
